import TransitionRouter from './transition-router.vue'
import NoRecord from './NoRecord/index.vue'
const myComponents = {
  install: function (Vue) {
    Vue.component('TransitionRouter', TransitionRouter)
    Vue.component('NoRecord', NoRecord)
  }
}

// 导出组件
export default myComponents
